import React from 'react';
import { PageHeroBreadcrumb } from '../components/layout/PageHeroBreadcrumb';
import { DoctorConsultation } from '../components/services/DoctorConsultation';
export function DoctorConsultationPage() {
  return <main className="flex-grow bg-gray-50 pt-[var(--header-height-mobile)] md:pt-[var(--header-height-desktop)]" data-id="element-6877" data-mp="2e7admmcwuta0">
      <PageHeroBreadcrumb breadcrumbs={[{
      label: 'Home',
      href: '/'
    }, {
      label: 'Doctor Consultation'
    }]} title="Doctor Consultation" description="Get expert medical advice from licensed healthcare professionals from the comfort of your home." data-id="element-6878" data-mp="2j63qcckdig94" />
      <div className="container mx-auto px-4 py-8" data-id="element-6879" data-mp="2080x1lkslx5i">
        <div className="max-w-3xl mx-auto" data-id="element-6880" data-mp="208st0xiaxwwb">
          <DoctorConsultation data-id="element-6881" data-mp="3pmz1dfxznwbv" />
        </div>
      </div>
    </main>;
}